import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPromoters } from "../../api/promotersApi";
import PageLoader from "../../components/pageLoader";
import ToastContainer from "../../components/toastContainer";
import Toast from "../../components/toast";
import { getGeneratedDocuments } from "../../api/documentsApi";
import { DocumentTextIcon } from "@heroicons/react/outline";

const GeneratedDocumentsPage = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);

  const navigate = useNavigate();


  const fetchDocuments = async () => {
    try {
      setLoading(true);

      const data = await getGeneratedDocuments();

      const list = Array.isArray(data) ? data : data.results || [];
      setDocuments(list);
    } catch (err) {
      setToast({
        type: "error",
        message:
          err?.response?.data?.detail || err?.detail || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, []);


  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <button
            onClick={() => navigate(-1)}
            className="text-sm text-slate-400 hover:text-white"
          >
            ← Back to Documents
          </button>
        </div>
      </div>

      <div className="bg-slate-900/60 border border-white/10 rounded-xl overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="border-b border-white/10 text-slate-400">
            <tr>
              <th className="px-6 py-3 text-left">Id</th>
              <th className="px-6 py-3 text-center">Name</th>
              <th className="px-6 py-3 text-center">File</th>
              <th className="px-6 py-3 text-center">Status</th>
            </tr>
          </thead>

          <tbody>
            {documents.map((doc) => (
              <tr
                key={doc.id}
                className="border-b border-white/5 hover:bg-slate-800/40 transition cursor-pointer"
              >
                <td className="px-6 py-4 text-white font-medium">{doc.id}</td>
                <td className="px-6 py-4 text-center text-white font-medium">{doc.name}</td>
                <td className="px-6 py-4 text-center">
                    {doc.file ? (
                      <button
                        onClick={() => window.open(doc.file, "_blank")}
                        className="text-pink-500"
                      >
                        <DocumentTextIcon className="w-5 h-5 inline" />
                      </button>
                    ) : (
                      <span className="text-slate-400">—</span>
                    )}
                  </td>
                <td className="px-6 py-4 text-center text-slate-300">
                  {doc.status}
                </td>
              </tr>
            ))}

            {!documents.length && (
              <tr>
                <td
                  colSpan={8}
                  className="px-6 py-10 text-center text-slate-400"
                >
                  No Documents found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <ToastContainer>
        {toast && (
          <Toast
            type={toast.type}
            message={toast.message}
            onClose={() => setToast(null)}
          />
        )}
      </ToastContainer>
    </div>
  );
};

export default GeneratedDocumentsPage;
